import InfoIcon from "@mui/icons-material/InfoOutline";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import { booleanToString, stringToBoolean } from "helpers";
import { Controller, useFormContext } from "react-hook-form";
import { UserProfileFormData } from "validations/userSchemas";

function AccountStatusSection() {
  const {
    control,
    formState: { errors },
  } = useFormContext<UserProfileFormData>();

  return (
    <Box className="space-y-4 mt-8">
      <Typography variant="h6" className="text-xl font-medium">
        Account Status
      </Typography>

      <FormControl component="fieldset" error={Boolean(errors.isActive)}>
        <Controller
          name="isActive"
          control={control}
          render={({ field }) => {
            const stringValue = booleanToString(field.value);

            return (
              <RadioGroup
                name="isActive"
                value={stringValue}
                onChange={(e) => {
                  const boolValue = stringToBoolean(e.target.value);
                  field.onChange(boolValue);
                }}
              >
                <Box>
                  <FormControlLabel
                    value="true"
                    control={<Radio />}
                    label={
                      <Box className="flex items-center gap-1">
                        <span>Active</span>
                        <Tooltip
                          title="The user will be able to use the platform"
                          arrow
                          placement="right"
                        >
                          <InfoIcon
                            fontSize="small"
                            sx={{
                              color: "text.secondary",
                              cursor: "help",
                              "&:hover": {
                                color: "primary.main",
                              },
                            }}
                          />
                        </Tooltip>
                      </Box>
                    }
                  />
                  <FormControlLabel
                    value="false"
                    control={<Radio />}
                    label={
                      <Box className="flex items-center gap-1">
                        <span>Inactive</span>
                        <Tooltip
                          title="The user will NOT be able to use the platform"
                          arrow
                          placement="right"
                        >
                          <InfoIcon
                            fontSize="small"
                            sx={{
                              color: "text.secondary",
                              cursor: "help",
                              "&:hover": {
                                color: "primary.main",
                              },
                            }}
                          />
                        </Tooltip>
                      </Box>
                    }
                  />
                </Box>
              </RadioGroup>
            );
          }}
        />
        {errors.isActive && (
          <FormHelperText>{errors.isActive.message}</FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

export default AccountStatusSection;
